// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/VanillaMilk.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./MathCourseDetailImages/portalBackground.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./MathCourseDetailImages/benefit1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./MathCourseDetailImages/benefit2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./MathCourseDetailImages/benefit3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./MathCourseDetailImages/benefit4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./MathCourseDetailImages/benefit5.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./MathCourseDetailImages/benefit6.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./MathCourseDetailImages/benefit7.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./MathCourseDetailImages/benefit8.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./MathCourseDetailImages/benefit9.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./MathCourseDetailImages/benefit10.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./MathCourseDetailImages/benefitDetail.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./MathCourseDetailImages/highlight1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./MathCourseDetailImages/highlight2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./MathCourseDetailImages/highlight3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./MathCourseDetailImages/highlight4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./MathCourseDetailImages/highlight5.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./MathCourseDetailImages/highlight6.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./MathCourseDetailImages/highlight7.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./MathCourseDetailImages/highlight8.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./MathCourseDetailImages/highlight9.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./MathCourseDetailImages/highlight10.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("./MathCourseDetailImages/highlight11.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("./MathCourseDetailImages/highlight12.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face{

    font-family: 'VanillaMilk';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.MathPortalBackground{
    width: 100%;
    height:600px;
    display: flex;
    background:  url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover; 
    position: relative;
}
.overlay
{
  width: 100%;
  height: 100%;
  
  position: absolute;
}
 

.PageHead
{
    font-family: 'VanillaMilk';
    font-size: 60px;
    color: white;
    text-align: center;
    z-index: 1;
    padding: 20px;
}

.PageDesc
{
    
    font-family: 'DM Sans', sans-serif;
    text-decoration-color: white;
    text-align: left;
    padding: 30px;
    font-size: 22px;
    z-index: 1;
}

.section
{
    align-items: center;
    justify-content: space-evenly;
    display: flex;
    margin: auto;
    max-width: 90%;
    flex-direction: column;
}
.course-structure,.fee-structure{
    background-color: #d8f2fb;
   max-width:  100%;
}
.compass-image{
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background: url(./MathCourseDetailImages/Compass.png); */
    background-size: cover;
    position: relative;
    margin: 2%;
}
.modules
{
    margin-top: 2vh;
}
.small-box{
    border: 2px solid ;
    width: 30vh;
    height:10vh;
    text-align: center;
    background-color: #fad5f1;
    font-size: 15px;
    font-weight: bold;
   margin:3vh 1vh 0 0;
    float: left;
    border-radius: 5px;
    position: relative;
}
 .sm-box
 {
    margin-left: -2px;
 }
.large-box{
    border: 2px solid ;
    width: 100vh;
    height: 28vh;
    text-align: center;
    background-color: #fad5f1;
    font-size: 20px;
    font-weight: bold;
    float: left;
    margin: 0px  3px 3px 3px;
    border-radius: 5px;
}
.round-box{
    border: 4px solid #fad5f1;
    width: 20vh;
    height:20vh;
    text-align: center;
    background-color: #d67fb2;
    font-size: 16px;
    font-weight: bolder;
    float: left;
    border-radius: 10vh;
    position: relative;
}
.smallbox{
    border: 2px solid ;
    width: 30vh;
    height:10vh;
    text-align: center;
    background-color: #fad5f1;
    font-size: 15px;
    font-weight: bold;
    margin:3vh 1vh 0 0;
    float: left;
    border-radius: 5px;
    position: relative;
}
.largebox{
    border: 2px solid ;
    width: 100vh;
    height: 28vh;
    text-align: center;
    background-color: #fad5f1;
    font-size: 20px;
    font-weight: bold;
    float: left;
    margin: 0px  3px 3px 3px;
    border-radius: 5px;
}
.roundbox{
    border: 4px solid #fad5f1;
    width: 20vh;
    height:20vh;
    text-align: center;
    background-color: #d67fb2;
    font-size: 16px;
    font-weight: bolder;
    float: left;
    border-radius: 10vh;
    position: relative;
}

.roundbox1{
    border: 4px solid #c7cff5;

background-color: #5e6fab;
}
.smallbox1{
    
    background-color: #c7cff5;
    border: 2px solid #5e6fab;

}
.largebox1{
    background-color: #c7cff5;
    border: 2px solid #5e6fab;

}


.roundbox2{
    background-color:#eca222 ;
    border: 2px solid #faf0d0;
}
.smallbox2{
    
    background-color: #faf0d0;
    border: 2px solid #eca222;

}
.largebox2{
    background-color: #faf0d0;
    border: 2px solid #eca222;

}
 

/* Create three columns of equal width */
.columns {
    float: left;
    width: 33.3%;
    padding: 8px;
  }
  
  /* Style the list */
  .price {
    list-style-type: none;
    border: 1px solid #eee;
    margin: 0;
    padding: 0;
    transition: 0.3s;
  }
  
  /* Add shadows on hover */
  .price:hover {
    box-shadow: 0 8px 12px 0 rgba(0,0,0,0.2)
  }
  
  /* Pricing header */
  .price .header {
    background-color: #249935;
    color: white;
    font-size: 25px;
  }
  
  /* List items */
  .price li {
    border-bottom: 1px solid rgb(255, 255, 255);
    padding: 20px;
    text-align: center;
  }
  
  /* Grey list item */
  .price .grey {
    background-color: #cff7d5;
    font-size: 20px;
  }
  
  /* The "Sign Up" button */
  .button {
    background-color: #03b4c6;
    border: none;
    color: white;
    padding: 10px 25px;
    text-align: center;
    text-decoration: none;
    font-size: 18px;
  }
  .b-img1{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); 
}.b-img2{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); 
}.b-img3{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); 
}.b-img4{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); 
}.b-img5{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); 
}.b-img6{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___}); 
}.b-img7{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___}); 
}.b-img8{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___}); 
}.b-img9{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___}); 
}.b-img10{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___}); 
}

.benefit-img{
    width: 50vh;
    height: 20vh; 

    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
}
.benefit-title{
    font-size: medium;
    color: #42869a;
    margin-left: 5rem;
    word-break: break-word;
    width: 25vh;
}
.benefit-detail-background{
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___}); 
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
}
.highlightTitleSection{
    padding-top: 3em;
    margin-left: 3em;
}
.benefit-resp-text
{
    margin-left: 0vh;
    width: 30vh;
    font-size: 15px;
    color: rgb(0, 169, 201);
}
.imgbene-resp{
    /* width: 355px; */
        height: -webkit-fill-available;
}
.wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
}
.accordian{
    width: 130vh;
}
.item{
    background: white;
    margin-bottom: 5px;
}
.title{
    width: 285px;
    height: 90px;
    color:green ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}
.content{
    /* color: #42869a; */
    max-height: 0;
    overflow: hidden;
    transition: all 0.5s cubic-bezier(0,1,0,1);
}
.content.show{
    /* max-width: "150vh"; background: "white"; margin-bottom: "5px"; border: '1px solid'; */
    height: auto;
    max-height: 9999px; 
    transition: all 0.5s cubic-bezier(0,1,0,1);

}
.span{
    margin-left: 50vh;
}
.fa-angle-down,.fa-angle-up{
    /* color: #5b1b05; */
    font-size: 8vh;
    float: right;
    /* display: flex;
    align-items: flex-end;
    justify-content: end; */
    /* margin-left: 40vh; */
}

.benefit-img{
    width: 285px;
    height: 90px;
    color:green ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ; 
    
    margin-top: 10px;
}

.gfg {
    /* margin-left:10vh ; */
    /* #5b1b05ed; */
    /* margin: 3%; */
    width: 150vh;
    height: 20vh;
    position: relative;
     
    background-color: rgb(255, 255, 255);
}

.first-txt {
    position: absolute;
    top: 17px;
    left: 50px;
}

.second-txt {
    position: absolute;
    bottom: 20px;
    left: 25vh;

}
.div-center{
    display: flex;
    align-items: center;
    justify-content: center;
}

.h-img1{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___}); 
}.h-img2{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___}); 
}.h-img3{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___}); 
}.h-img4{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___}); 
}.h-img5{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}); 
}.h-img6{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}); 
}.h-img7{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___}); 
}.h-img8{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___}); 
}.h-img9{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___}); 
}.h-img10{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___}); 
}.h-img11{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___}); 
}.h-img12{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___}); 
}

.highlight-img{
    width: 178px;
    height: 319px; 

    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
}
.highlight-title{
    font-size: medium;
    color: #42869a;
    margin-top: 10rem;
    margin-left: 1rem;
        border-bottom-color: #424242;
    word-break: break-word;
}
.gfg-highlights {
   
    width: 150vh;
    height: 20vh;
    position: relative;
     
    background-color:transparent;
}
a:link { text-decoration: none; }
a:hover {color: white;}
.btn-row{
    width: 100%;
    height: 5em;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2em;
}
.btn-color-course{
    background-color: #e683e4;
}
.btn-color-portal{
    background-color: #e2e872;}
.btn-color-fee{
    background-color: #f09c60;}
.btn-color-Testimonal{
    background-color: #dbaf1f;
}.btn-color-Faq{
    background-color: #688cd9;
}.btn-color-registered{
    background-color: #37b33e;
}
html {
    scroll-behavior: smooth;
  }
.button{
  
    padding: 20px;
    color: white;
    font-size: 16px;
    font-weight: bold;
    border: none;
    font-family: sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/MathPortal/MathCourseDetails.css"],"names":[],"mappings":"AAAA;;IAEI,0BAA0B;IAC1B,4CAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oDAAiE;IACjE,sBAAsB;IACtB,kBAAkB;AACtB;AACA;;EAEE,WAAW;EACX,YAAY;;EAEZ,kBAAkB;AACpB;;;AAGA;;IAEI,0BAA0B;IAC1B,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,aAAa;AACjB;;AAEA;;;IAGI,kCAAkC;IAClC,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,UAAU;AACd;;AAEA;;IAEI,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,YAAY;IACZ,cAAc;IACd,sBAAsB;AAC1B;AACA;IACI,yBAAyB;GAC1B,gBAAgB;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2DAA2D;IAC3D,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;AACd;AACA;;IAEI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;GAClB,kBAAkB;IACjB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;CACC;;IAEG,iBAAiB;CACpB;AACD;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,wBAAwB;IACxB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,wBAAwB;IACxB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;;AAE7B,yBAAyB;AACzB;AACA;;IAEI,yBAAyB;IACzB,yBAAyB;;AAE7B;AACA;IACI,yBAAyB;IACzB,yBAAyB;;AAE7B;;;AAGA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;;IAEI,yBAAyB;IACzB,yBAAyB;;AAE7B;AACA;IACI,yBAAyB;IACzB,yBAAyB;;AAE7B;;;AAGA,wCAAwC;AACxC;IACI,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA,mBAAmB;EACnB;IACE,qBAAqB;IACrB,sBAAsB;IACtB,SAAS;IACT,UAAU;IAEV,gBAAgB;EAClB;;EAEA,yBAAyB;EACzB;IACE;EACF;;EAEA,mBAAmB;EACnB;IACE,yBAAyB;IACzB,YAAY;IACZ,eAAe;EACjB;;EAEA,eAAe;EACf;IACE,2CAA2C;IAC3C,aAAa;IACb,kBAAkB;EACpB;;EAEA,mBAAmB;EACnB;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA,yBAAyB;EACzB;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,yDAA8D;AAClE,CAAC;IACG,yDAA8D;AAClE,CAAC;IACG,yDAA8D;AAClE,CAAC;IACG,yDAA8D;AAClE,CAAC;IACG,yDAA8D;AAClE,CAAC;IACG,yDAA8D;AAClE,CAAC;IACG,yDAA8D;AAClE,CAAC;IACG,yDAA8D;AAClE,CAAC;IACG,0DAA8D;AAClE,CAAC;IACG,0DAA+D;AACnE;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;AAChC;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,0DAAmE;IACnE,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;AAChC;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;;IAEI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,kBAAkB;QACd,8BAA8B;AACtC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,oBAAoB;IACpB,aAAa;IACb,gBAAgB;IAChB,0CAA0C;AAC9C;AACA;IACI,wFAAwF;IACxF,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;;AAE9C;AACA;IACI,iBAAiB;AACrB;AACA;IACI,oBAAoB;IACpB,cAAc;IACd,YAAY;IACZ;;2BAEuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;;IAE5B,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;;IAElB,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;;AAEd;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0DAAgE;AACpE,CAAC;IACG,0DAAgE;AACpE,CAAC;IACG,0DAAgE;AACpE,CAAC;IACG,0DAAgE;AACpE,CAAC;IACG,0DAAgE;AACpE,CAAC;IACG,0DAAgE;AACpE,CAAC;IACG,0DAAgE;AACpE,CAAC;IACG,0DAAgE;AACpE,CAAC;IACG,0DAAgE;AACpE,CAAC;IACG,0DAAiE;AACrE,CAAC;IACG,0DAAiE;AACrE,CAAC;IACG,0DAAiE;AACrE;;AAEA;IACI,YAAY;IACZ,aAAa;;IAEb,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;AAChC;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;QACb,4BAA4B;IAChC,sBAAsB;AAC1B;AACA;;IAEI,YAAY;IACZ,YAAY;IACZ,kBAAkB;;IAElB,4BAA4B;AAChC;AACA,SAAS,qBAAqB,EAAE;AAChC,SAAS,YAAY,CAAC;AACtB;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB,CAAC;AAC9B;IACI,yBAAyB,CAAC;AAC9B;IACI,yBAAyB;AAC7B,CAAC;IACG,yBAAyB;AAC7B,CAAC;IACG,yBAAyB;AAC7B;AACA;IACI,uBAAuB;EACzB;AACF;;IAEI,aAAa;IACb,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;AAC3B","sourcesContent":["@font-face{\n\n    font-family: 'VanillaMilk';\n    src: url('../fonts/VanillaMilk.otf');\n}\n\n.MathPortalBackground{\n    width: 100%;\n    height:600px;\n    display: flex;\n    background:  url('./MathCourseDetailImages/portalBackground.png');\n    background-size: cover; \n    position: relative;\n}\n.overlay\n{\n  width: 100%;\n  height: 100%;\n  \n  position: absolute;\n}\n \n\n.PageHead\n{\n    font-family: 'VanillaMilk';\n    font-size: 60px;\n    color: white;\n    text-align: center;\n    z-index: 1;\n    padding: 20px;\n}\n\n.PageDesc\n{\n    \n    font-family: 'DM Sans', sans-serif;\n    text-decoration-color: white;\n    text-align: left;\n    padding: 30px;\n    font-size: 22px;\n    z-index: 1;\n}\n\n.section\n{\n    align-items: center;\n    justify-content: space-evenly;\n    display: flex;\n    margin: auto;\n    max-width: 90%;\n    flex-direction: column;\n}\n.course-structure,.fee-structure{\n    background-color: #d8f2fb;\n   max-width:  100%;\n}\n.compass-image{\n    width: 100%;\n    height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    /* background: url(./MathCourseDetailImages/Compass.png); */\n    background-size: cover;\n    position: relative;\n    margin: 2%;\n}\n.modules\n{\n    margin-top: 2vh;\n}\n.small-box{\n    border: 2px solid ;\n    width: 30vh;\n    height:10vh;\n    text-align: center;\n    background-color: #fad5f1;\n    font-size: 15px;\n    font-weight: bold;\n   margin:3vh 1vh 0 0;\n    float: left;\n    border-radius: 5px;\n    position: relative;\n}\n .sm-box\n {\n    margin-left: -2px;\n }\n.large-box{\n    border: 2px solid ;\n    width: 100vh;\n    height: 28vh;\n    text-align: center;\n    background-color: #fad5f1;\n    font-size: 20px;\n    font-weight: bold;\n    float: left;\n    margin: 0px  3px 3px 3px;\n    border-radius: 5px;\n}\n.round-box{\n    border: 4px solid #fad5f1;\n    width: 20vh;\n    height:20vh;\n    text-align: center;\n    background-color: #d67fb2;\n    font-size: 16px;\n    font-weight: bolder;\n    float: left;\n    border-radius: 10vh;\n    position: relative;\n}\n.smallbox{\n    border: 2px solid ;\n    width: 30vh;\n    height:10vh;\n    text-align: center;\n    background-color: #fad5f1;\n    font-size: 15px;\n    font-weight: bold;\n    margin:3vh 1vh 0 0;\n    float: left;\n    border-radius: 5px;\n    position: relative;\n}\n.largebox{\n    border: 2px solid ;\n    width: 100vh;\n    height: 28vh;\n    text-align: center;\n    background-color: #fad5f1;\n    font-size: 20px;\n    font-weight: bold;\n    float: left;\n    margin: 0px  3px 3px 3px;\n    border-radius: 5px;\n}\n.roundbox{\n    border: 4px solid #fad5f1;\n    width: 20vh;\n    height:20vh;\n    text-align: center;\n    background-color: #d67fb2;\n    font-size: 16px;\n    font-weight: bolder;\n    float: left;\n    border-radius: 10vh;\n    position: relative;\n}\n\n.roundbox1{\n    border: 4px solid #c7cff5;\n\nbackground-color: #5e6fab;\n}\n.smallbox1{\n    \n    background-color: #c7cff5;\n    border: 2px solid #5e6fab;\n\n}\n.largebox1{\n    background-color: #c7cff5;\n    border: 2px solid #5e6fab;\n\n}\n\n\n.roundbox2{\n    background-color:#eca222 ;\n    border: 2px solid #faf0d0;\n}\n.smallbox2{\n    \n    background-color: #faf0d0;\n    border: 2px solid #eca222;\n\n}\n.largebox2{\n    background-color: #faf0d0;\n    border: 2px solid #eca222;\n\n}\n \n\n/* Create three columns of equal width */\n.columns {\n    float: left;\n    width: 33.3%;\n    padding: 8px;\n  }\n  \n  /* Style the list */\n  .price {\n    list-style-type: none;\n    border: 1px solid #eee;\n    margin: 0;\n    padding: 0;\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n  }\n  \n  /* Add shadows on hover */\n  .price:hover {\n    box-shadow: 0 8px 12px 0 rgba(0,0,0,0.2)\n  }\n  \n  /* Pricing header */\n  .price .header {\n    background-color: #249935;\n    color: white;\n    font-size: 25px;\n  }\n  \n  /* List items */\n  .price li {\n    border-bottom: 1px solid rgb(255, 255, 255);\n    padding: 20px;\n    text-align: center;\n  }\n  \n  /* Grey list item */\n  .price .grey {\n    background-color: #cff7d5;\n    font-size: 20px;\n  }\n  \n  /* The \"Sign Up\" button */\n  .button {\n    background-color: #03b4c6;\n    border: none;\n    color: white;\n    padding: 10px 25px;\n    text-align: center;\n    text-decoration: none;\n    font-size: 18px;\n  }\n  .b-img1{\n    background-image: url('./MathCourseDetailImages/benefit1.png'); \n}.b-img2{\n    background-image: url('./MathCourseDetailImages/benefit2.png'); \n}.b-img3{\n    background-image: url('./MathCourseDetailImages/benefit3.png'); \n}.b-img4{\n    background-image: url('./MathCourseDetailImages/benefit4.png'); \n}.b-img5{\n    background-image: url('./MathCourseDetailImages/benefit5.png'); \n}.b-img6{\n    background-image: url('./MathCourseDetailImages/benefit6.png'); \n}.b-img7{\n    background-image: url('./MathCourseDetailImages/benefit7.png'); \n}.b-img8{\n    background-image: url('./MathCourseDetailImages/benefit8.png'); \n}.b-img9{\n    background-image: url('./MathCourseDetailImages/benefit9.png'); \n}.b-img10{\n    background-image: url('./MathCourseDetailImages/benefit10.png'); \n}\n\n.benefit-img{\n    width: 50vh;\n    height: 20vh; \n\n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n}\n.benefit-title{\n    font-size: medium;\n    color: #42869a;\n    margin-left: 5rem;\n    word-break: break-word;\n    width: 25vh;\n}\n.benefit-detail-background{\n    width: 100%;\n    height: 100%;\n    background-image: url('./MathCourseDetailImages/benefitDetail.png'); \n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n}\n.highlightTitleSection{\n    padding-top: 3em;\n    margin-left: 3em;\n}\n.benefit-resp-text\n{\n    margin-left: 0vh;\n    width: 30vh;\n    font-size: 15px;\n    color: rgb(0, 169, 201);\n}\n.imgbene-resp{\n    /* width: 355px; */\n        height: -webkit-fill-available;\n}\n.wrapper{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.accordian{\n    width: 130vh;\n}\n.item{\n    background: white;\n    margin-bottom: 5px;\n}\n.title{\n    width: 285px;\n    height: 90px;\n    color:green ;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n}\n.content{\n    /* color: #42869a; */\n    max-height: 0;\n    overflow: hidden;\n    transition: all 0.5s cubic-bezier(0,1,0,1);\n}\n.content.show{\n    /* max-width: \"150vh\"; background: \"white\"; margin-bottom: \"5px\"; border: '1px solid'; */\n    height: auto;\n    max-height: 9999px; \n    transition: all 0.5s cubic-bezier(0,1,0,1);\n\n}\n.span{\n    margin-left: 50vh;\n}\n.fa-angle-down,.fa-angle-up{\n    /* color: #5b1b05; */\n    font-size: 8vh;\n    float: right;\n    /* display: flex;\n    align-items: flex-end;\n    justify-content: end; */\n    /* margin-left: 40vh; */\n}\n\n.benefit-img{\n    width: 285px;\n    height: 90px;\n    color:green ;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ; \n    \n    margin-top: 10px;\n}\n\n.gfg {\n    /* margin-left:10vh ; */\n    /* #5b1b05ed; */\n    /* margin: 3%; */\n    width: 150vh;\n    height: 20vh;\n    position: relative;\n     \n    background-color: rgb(255, 255, 255);\n}\n\n.first-txt {\n    position: absolute;\n    top: 17px;\n    left: 50px;\n}\n\n.second-txt {\n    position: absolute;\n    bottom: 20px;\n    left: 25vh;\n\n}\n.div-center{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.h-img1{\n    background-image: url('./MathCourseDetailImages/highlight1.png'); \n}.h-img2{\n    background-image: url('./MathCourseDetailImages/highlight2.png'); \n}.h-img3{\n    background-image: url('./MathCourseDetailImages/highlight3.png'); \n}.h-img4{\n    background-image: url('./MathCourseDetailImages/highlight4.png'); \n}.h-img5{\n    background-image: url('./MathCourseDetailImages/highlight5.png'); \n}.h-img6{\n    background-image: url('./MathCourseDetailImages/highlight6.png'); \n}.h-img7{\n    background-image: url('./MathCourseDetailImages/highlight7.png'); \n}.h-img8{\n    background-image: url('./MathCourseDetailImages/highlight8.png'); \n}.h-img9{\n    background-image: url('./MathCourseDetailImages/highlight9.png'); \n}.h-img10{\n    background-image: url('./MathCourseDetailImages/highlight10.png'); \n}.h-img11{\n    background-image: url('./MathCourseDetailImages/highlight11.png'); \n}.h-img12{\n    background-image: url('./MathCourseDetailImages/highlight12.png'); \n}\n\n.highlight-img{\n    width: 178px;\n    height: 319px; \n\n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n}\n.highlight-title{\n    font-size: medium;\n    color: #42869a;\n    margin-top: 10rem;\n    margin-left: 1rem;\n        border-bottom-color: #424242;\n    word-break: break-word;\n}\n.gfg-highlights {\n   \n    width: 150vh;\n    height: 20vh;\n    position: relative;\n     \n    background-color:transparent;\n}\na:link { text-decoration: none; }\na:hover {color: white;}\n.btn-row{\n    width: 100%;\n    height: 5em;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 2em;\n}\n.btn-color-course{\n    background-color: #e683e4;\n}\n.btn-color-portal{\n    background-color: #e2e872;}\n.btn-color-fee{\n    background-color: #f09c60;}\n.btn-color-Testimonal{\n    background-color: #dbaf1f;\n}.btn-color-Faq{\n    background-color: #688cd9;\n}.btn-color-registered{\n    background-color: #37b33e;\n}\nhtml {\n    scroll-behavior: smooth;\n  }\n.button{\n  \n    padding: 20px;\n    color: white;\n    font-size: 16px;\n    font-weight: bold;\n    border: none;\n    font-family: sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
